import { useState } from "react";
import { TableState } from "./types";

export const useTableState = <T extends Record<string, any>>() => {
  const [state, setState] = useState<TableState<T>>({
    sortColumn: null,
    sortDirection: null,
    selectedRows: new Set(),
    currentPage: 1,
    searchTerm: '',
    columnFilters: {},
    selectedFiltersByGroup: {},
  });

  const updateState = (updates: Partial<TableState<T>>) => {
    setState(prev => ({ ...prev, ...updates }));
  };

  return { state, updateState };
};
